export default "__VITE_ASSET__CNeFh1du__"